import entitiesReducer from "../lib/entitiesReducer";
import * as actions from "./actions";
import { Record, Map } from "immutable";
import { isApiCall } from "../app/schema";

import Menus from "./menus";

const feature = "menus";

const InitialState = Record({
  menus: new Menus()
});

const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function MenusReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return revive(state);

  if (isApiCall(action.type)) {
    if (
      action.payload && action.payload.entities && action.payload.entities.menus
    ) {
      state = state.updateIn(["menus", "entities"], map =>
        map.mergeDeep(action.payload.entities.menus));
    }
  }

  switch (action.type) {
    case actions.GET_MENUS: {
      return state.setIn(["menus", "loading"], true);
    }
    case actions.GET_MENUS_SUCCESS: {
      state = state.deleteIn(["menus", "entities"]);
      state = state.deleteIn(["menus", "results"]);
      state = state.setIn(
        ["menus", "meta", "all"],
        action.payload.result.meta.all
      );
      state = state.setIn(
        ["menus", "meta", "count"],
        action.payload.result.meta.count
      );
      state = state.updateIn(["menus", "entities"], map =>
        map.mergeDeep(action.payload.entities.menus));
      state = state.setIn(["menus", "results"], action.payload.result.menus);
      return state.setIn(["menus", "loading"], false);
    }
    case actions.GET_MENUS_ERROR: {
      return state.setIn(["menus", "loading"], false);
    }

    case actions.GET_MENU: {
      return state.setIn(["menus", "loading"], true);
    }
    case actions.GET_MENU_SUCCESS: {
      return state.setIn(["menus", "loading"], false);
    }
    case actions.GET_MENU_ERROR: {
      return state.setIn(["menus", "loading"], false);
    }

    case actions.PATCH_MENU: {
      return state.setIn(["menus", "loading"], true);
    }
    case actions.PATCH_MENU_SUCCESS: {
      return state.setIn(["menus", "loading"], false);
    }
    case actions.PATCH_MENU_ERROR: {
      return state.setIn(["menus", "loading"], false);
    }

    case actions.DELETE_MENU: {
      return state.deleteIn(["menus", "entities", action.payload.uid]);
    }

    case actions.SET_IS_EDIT_MENU_ITEM_MODAL_VISIBLE: {
      return state.setIn(
        ["menus", "isEditModalVisible"],
        action.payload.isVisible
      );
    }
    case actions.SET_IS_REMOVE_MENU_ITEM_MODAL_VISIBLE: {
      return state.setIn(
        ["menus", "isRemoveModalVisible"],
        action.payload.isVisible
      );
    }

  }

  return entitiesReducer(state, feature, action);
}



// WEBPACK FOOTER //
// ./src/common/menus/reducer.js